import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { fmtDataBR } from "@/components/ChatServico";

// Reaproveitamento das datas alternativas do cliente (GET datas-alternativas / POST reaproveitar-data)
export function RetomadaDatas({ servicoId, s, onSaved, titulo = "Retomar atendimento",
  semDatasTexto = "Solicite o reagendamento formal da OS." }) {
  const [info, setInfo] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get(`/servicos/${servicoId}/datas-alternativas`)
      .then((r) => setInfo(r.data))
      .catch(() => setInfo(null));
  }, [servicoId, s.status, s.data_confirmada]);
  if (!info) return null;
  const escolher = async (data, confirmar = false) => {
    setBusy(true);
    try {
      const r = await api.post(`/servicos/${servicoId}/reaproveitar-data`,
        { data_escolhida: data, confirmar_ultima_data: confirmar });
      if (r.data?.alerta_ultima_data) {
        setBusy(false);
        if (window.confirm(r.data.mensagem)) return escolher(data, true);
        return;
      }
      toast.success(`Nova data confirmada: ${fmtDataBR(r.data.data_confirmada)}`);
      onSaved();
    } catch (e) {
      toast.error(formatApiError(e));
    }
    setBusy(false);
  };
  return (
    <div className="border-2 border-[#F5C518] bg-[#FFFBEA] p-5" data-testid="retomada-datas">
      <div className="label-cap mb-2">{titulo}</div>
      {info.bloqueio_assistencia ? (
        <div className="text-sm" data-testid="retomada-assistencia">{info.bloqueio_assistencia}</div>
      ) : info.sem_alternativas ? (
        <div className="text-sm" data-testid="retomada-sem-datas">
          Não há datas alternativas futuras entre as 5 informadas pelo cliente.
          {" "}{semDatasTexto}
        </div>
      ) : (
        <>
          <div className="text-sm mb-3">Escolha uma das datas que o cliente já havia informado:</div>
          <div className="space-y-2">
            {info.datas.map((d) => (
              <Button key={d.data} disabled={!d.disponivel || busy}
                onClick={() => escolher(d.data)}
                className="w-full btn-sharp brand-bg text-white h-12"
                data-testid={`retomada-data-${d.data}`}>
                {fmtDataBR(d.data)}{d.disponivel ? "" : ` — ${d.motivo}`}
              </Button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
